<template>
    <div style="margin: 10px">
        <v-form>
            <v-card>
                <div class="headline dialog-header">
                    <v-toolbar color="primary" dark>
                        <v-toolbar-title style="padding-left: 10px"
                            >{{ $t(formName) }}
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-btn
                        @click="onCancel"
                        icon
                        style="
                            position: absolute;
                            right: 10px;
                            top: 10px;
                            color: #fff;
                        "
                    >
                        <v-icon>cancel</v-icon>
                    </v-btn>
                </div>
                <v-card-text>
                    <v-layout wrap>
                        <v-flex xs12 sm12 md6>
                            <div style="padding: 20px 10px">
                                <p class="font-weight-bold">
                                    Số thông báo: {{ importRequest != null ? importRequest.requestNumber : '' }}
                                </p>
                                <p class="font-weight-bold">
                                    Mã kho: {{ warehouseCode }}
                                </p>
                                <div v-if="isEdit">
                                    <v-textarea
                                        outlined
                                        label="Nội dung"
                                        rows="2"
                                        v-model="importRequest.content"
                                    />
                                </div>
                                <p v-else class="font-weight-bold">
                                    Nội dung: {{ importRequest != null ? importRequest.content : '' }}
                                </p>

                                <div v-if="isEdit">
                                    <i-datepicker
                                        label="Ngày dự kiến giao hàng"
                                        v-model="importRequest.dateArrived"
                                        :minDate="minDate()"
                                    />
                                </div>
                                <p v-else class="font-weight-bold">
                                    Ngày dự kiến giao hàng: {{ importRequest != null ? this.dateFormat(importRequest.dateArrived) : '' }}
                                </p>

                                <p class="font-weight-bold">
                                    Trạng thái: 
                                    <span v-if="importRequest.status == 1" style="color: #d9d900">Chưa giao hàng</span>
                                    <span v-else-if="importRequest.status == 2" style="color: green">Đã giao hàng</span>
                                </p>
                            </div>
                        </v-flex>
                        <v-flex xs12 sm12 md6>
                            
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex>
                            <table class="lstTable">
                                <tr>
                                    <th width="10%">{{$t('lang.material.materialType')}}</th>
                                    <th width="10%">Tên vật tư</th>
                                    <th width="10%">Đơn vị</th>
                                    <th width="10%">Đóng gói</th>
                                    <th width="10%">Số lượng đề xuất</th>
                                    <th width="10%">Số lượng dự kiến</th>
                                    <!-- <th width="10%">Tổng số lượng thực nhập</th> -->
                                    <th width="10%">Số lượng thực nhập lũy kế</th>
                                    <th width="20%">Nhà cung cấp</th>
                                    <th width="10%">Ghi chú</th>
                                </tr>
                                <template v-for="(item, index) in lstMaterial">
                                    <tr v-if="item.row === 0" :key="index">
                                        <td style="font-weight: bold">{{item.typeName}}</td>
                                        <td colspan="7">Không có vật tư</td>
                                    </tr>

                                    <tr v-else :key="index">
                                        <td :rowspan="item.row" v-if="item.row != undefined && item.row > 0" style="font-weight: bold">{{item.typeName}}</td>
                                        <td>{{ item.materialName }}</td>
                                        <td style="text-align: center">{{ item.unit }}</td>
                                        <td style="text-align: center">{{ item.pack }}</td>
                                        <td style="text-align: center">{{ (item.buyNumberPropose != undefined ? item.buyNumberPropose : 0) | currency }}</td>
                                        <td>
                                          <c-input-number
                                                v-if="isEdit"
                                                min="0"
                                                v-model="lstMaterial[index].orderQuantity"
                                                v-on:input="setInput"
                                                @keydown="keyProcess"
                                                :id="'input_' + index"
                                                :data-index="index"
                                                style="text-align: center"
                                            />
                                            <div v-else style="text-align: center">{{ (item.orderQuantity != undefined ? item.orderQuantity : 0) | currency }}</div>
                                        </td>
                                        <td style="text-align: center">{{ (item.totalImportQuantity != undefined ? item.totalImportQuantity : 0) | currency }}</td>
                                        <!-- <td style="text-align: center">{{ item.totalImportQuantityAcc != undefined ? item.totalImportQuantityAcc : 0 }}</td> -->
                                        <td>
                                            <v-autocomplete
                                                v-if="isEdit"
                                                :items="fomarLstSupplier(lstMaterial[index])"
                                                label="Nhà cung cấp"
                                                v-model="lstMaterial[index].supplyId"
                                                item-value="partnerId"
                                                item-text="partnerName"
                                                clearable
                                            />
                                            <template v-else v-for="(supplier, i) in lstSupplier">
                                                <span v-if="supplier.partnerId == item.supplyId" :key="i">
                                                    {{ supplier.partnerName }}
                                                </span>
                                            </template>
                                        </td>
                                        <td style="text-align: center">{{ item.pur_note != undefined ? item.pur_note : '' }}</td>
                                    </tr>
                                </template>
                            </table>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn color="info" @click="historyDlg=true" v-if="importRequest.importRequestId != undefined && importRequest.importRequestId != null">
                        {{ $t("lang.common.history") }}
                    </v-btn>
                    <template v-if="importRequest.status == 1 && roleGroup == 1">
                        <!-- <v-btn v-if="!isEdit" color="info" @click="onEdit" :disabled="loading">
                            {{ $t("lang.common.edit") }}
                        </v-btn> -->
                        <v-btn v-if="isEdit" color="primary" @click="onSave" :disabled="loading">
                            {{ $t("lang.common.update") }}
                        </v-btn>
                        <v-btn v-if="showDelete" color="error" @click="onDelete" :disabled="loading">
                            {{ $t("lang.common.delete") }}
                        </v-btn>
                    </template>
                    <v-btn v-if="importRequest.status == 2 && roleGroup != 0" color="primary" @click="onView" :disabled="loading">
                        {{ $t("Xem phiếu nhập kho") }}
                    </v-btn>
                    <v-btn v-if="importRequest.status == 1 && roleGroup == 2" color="primary" @click="onImportWhCreate" :disabled="loading">
                        {{ $t("Tạo phiếu nhập kho") }}
                    </v-btn>
                    <v-btn color="grey" @click="onCancel" :disabled="loading">
                        {{ $t("lang.common.back") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-form>

        <v-dialog
            v-model="deleteDialog"
            persistent
            max-width="290"
        >
            <v-card>
                <v-card-title class="text-h3">
                Bạn có muốn xóa thông báo này ?
                </v-card-title>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" text  @click="deleteDialog = false">
                    Hủy bỏ
                </v-btn>
                <v-btn color="success" text @click="agreeDelete">
                    Đồng ý
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="historyDlg" width="800px" persistent>
            <v-form data-vv-name="historyForm">
                <v-card>
                    <div class="headline dialog-header">
                        <v-toolbar color="primary" dark>
                            <v-toolbar-title style="padding-left: 10px">
                            Lịch sử
                            </v-toolbar-title>
                        </v-toolbar>
                        <v-btn
                            @click="historyDlg=false"
                            icon
                            style="position: absolute; right: 10px; top: 10px; color: #fff"
                        >
                            <v-icon>cancel</v-icon>
                        </v-btn>
                    </div>
                    <v-card-text>
                        <table class="lstTable" v-if="lstHistory.length>0">
                            <tr>
                                <th width="20%">Thời gian</th>
                                <th width="15%">Người xử lý</th>
                                <th width="15%">Xử lý</th>
                                <th width="50%">Nội dung</th>
                                </tr>
                                <tr v-for="item in lstHistory">
                                <td>{{item.actionTime|formatDateTime}}</td>
                                <td><label style="font-weight: bold;color:blue">{{item.userName}}</label></td>
                                <td>{{item.action}}</td>
                                <td><label v-if="item.actionContent"> {{item.actionContent}}</label></td>
                            </tr>
                        </table>
                        <div v-else style="border:1px solid grey;border-radius: 10px;padding: 10px">Không có lịch sử
                        </div>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer/>
                        <v-btn @click="historyDlg=false">{{$t('lang.common.close')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
    </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import IDatepicker from "../../../components/form/DatePicker";
import { message } from "../../../shared/message";
import CTextboxFloat from "@/components/form/TextboxFloat";

export default {
    name: "ImportRequestView",
    components: {CTextboxFloat, IDatepicker },
    data: () => {
        return {
            formName: "Thông báo",
            loading: false,
            warehouseCode: "",
            roleGroup: 0,
            userId: '',
            isEdit: false,
            deleteDialog: false,
            materials: [],
            lstSupplier: [],
            lstWarehouse: [],
            lstMaterialType: [],
            lstMaterial: [],
            lstMaterialFull: [],
            requestOrder: null,
            importRequest: {
                status: 1,
                dateArrived: '',
            },
          historyDlg: false,
          lstHistory: [],
        };
    },

    created() {
        // 2: thủ kho;  26: mua hàng
        this.userId = parseInt(this.$store.state.auth.user.userId);
        const role = parseInt(this.$store.state.auth.user.role);
        if (role == 26 || role == 3) {
            this.roleGroup = 1;
            this.isEdit = true;
        } else if (role == 2) {
            this.roleGroup = 2;
        } else if (role == 1 || role == 15) {
            this.roleGroup = 3;
        } else {
            this.$router.push({ path: '/importRequest' });
        }

        this.getImportRequest();
        this.getMaterialFull();
        this.getSuppliers();
    },

    computed: {
        showDelete() {
            if(this.$store.state.auth.user.userId == this.importRequest.userCreateId){
                return true;
            } else {
                return false;
            }
        },
    },

    methods: {
        //linhdx reload lai array thi moi hien thi dc c-textbox-float
        setInput(){
          this.lstMaterial = [...this.lstMaterial]
        },
        onCancel() {
            //this.$router.push({ path: '/importRequest' });
            this.$router.push({ path: '/importRequest', query: this.$route.query });
        },
        onSave() {
            const totalOrderQuantity = this.lstMaterial.reduce((n, {orderQuantity}) => n + orderQuantity, 0)
            if (parseInt(totalOrderQuantity) <= 0) {
                message.error("Bạn chưa nhập số lượng vật tư dự kiến giao");
                return;
            }

            this.loading = true;

            const createItem = this.importRequest;
            createItem.requestData = JSON.stringify(this.lstMaterial);
            // return;

            axios
                .post(process.env.VUE_APP_API_URL + "/importRequest/save", createItem)
                .then(
                    (data) => {
                        if (data.success) {
                            message.success(
                                this.$t("lang.common.save_success")
                            );
                            this.onCancel();
                        } else {
                            message.error(this.$t(data.description));
                        }
                        this.loading = false;
                        // this.isEdit = false;
                    },
                    (error) => {
                        this.loading = false;
                        // this.isEdit = false;
                        console.log(error);
                    }
                );
        },
        onView() {
            this.$router.push({ path: '/importRequest/importWhView/' + this.$route.params.id });
        },
        onEdit() {
            this.isEdit = true;
        },
        onDelete() {
            this.deleteDialog = true;
        },
        agreeDelete() {
            axios
                .post(process.env.VUE_APP_API_URL + "/importRequest/delete", this.importRequest)
                .then(
                    (data) => {
                        if (data) {
                            message.success(this.$t("lang.common.delete_success"));
                            this.$router.push({ path: '/importRequest' });
                        }
                        this.loading = false;
                    },
                    (error) => {
                        this.loading = false;
                        console.log(error);
                    }
                );
        },
        onImportWhCreate() {
            this.$router.push({ path: '/importRequest/importWhCreate/' + this.$route.params.id });
        },
        getImportRequest() {
            if (this.$route.params.id) {
                axios
                    .post(
                        process.env.VUE_APP_API_URL + "/importRequest/detail/" + this.$route.params.id
                    )
                    .then((data) => {
                        if (typeof data == "object") {
                            data.dateArrived = moment(String(data.dateArrived)).format('YYYY-MM-DD');
                            this.importRequest = data;
                            if (data.status == 2) {
                                this.isEdit = false;
                            }
                            this.getRequestOrder(data.reqOrdId);
                            this.getWarehouses(data.warehouseId);
                            this.getHistory(this.importRequest);
                            this.lstMaterial = JSON.parse(data.requestData);
                            this.checkMaterialTypePermission();
                        }
                    });
            }
        },
        getRequestOrder(id) {
            if (id) {
                axios
                    .post(
                        process.env.VUE_APP_API_URL + "/requestOrder/detail/" + id
                    )
                    .then((data) => {
                        if (typeof data == "object") {
                            this.requestOrder = data;
                        }
                    });
            }
        },
        getSuppliers() {
            axios.post(
                    process.env.VUE_APP_API_URL + "/partner/suppliers?pageSize=-1&page=-1",
                    { status: 1 }
                )
                .then((data) => {
                    if (data.items) {
                        this.lstSupplier = data.items;
                    }
                });
        },
        getMaterialFull() {
            axios
                .post(
                    process.env.VUE_APP_API_URL + "/material/search?pageSize=-1&page=-1", {}
                )
                .then((data) => {
                    if (data.items) {
                        this.lstMaterialFull = data.items;
                    }
                });
        },
        getWarehouses(categoryId) {
            axios
                .post(
                    process.env.VUE_APP_API_URL + "/category/onSearchAllStatus?pageSize=-1&page=-1&categoryTypeCode=WAREHOUSE",
                    { categoryId }
                )
                .then((data) => {
                    if (data.items != undefined && data.items.length > 0) {
                        this.warehouseCode = data.items[0].categoryName;
                    }
                });
        },
        keyProcess($event) {
            let index = parseInt($event.target.getAttribute("data-index"));
            let input_id = '';
            switch ($event.keyCode) {
                case 13:
                    index += 1;
                    input_id = "input_" + index;
                    var element = document.getElementById(input_id);
                    if (typeof element != "undefined" && element != null) {
                        element.focus();
                    } else {
                        $event.target.blur(); 
                    }
                    $event.preventDefault();
                    break;
                case 38:
                    // up
                    if (index > 0) {
                        index -= 1;
                        input_id = "input_" + index;
                        var element = document.getElementById(input_id);
                        if (typeof element != "undefined" && element != null) {
                            element.focus();
                        }
                    }
                    $event.preventDefault();
                    break;
                case 40:
                    //down
                    index += 1;
                    input_id = "input_" + index;
                    var element = document.getElementById(input_id);
                    if (typeof element != "undefined" && element != null) {
                        element.focus();
                    }
                    $event.preventDefault();
                    break;
            }
        },
        minDate() {
            const minDate = moment().format('YYYY-MM-DD');
            return minDate;
        },
        fomarLstSupplier(item) {
            let supplier = [];
            if (this.lstSupplier.length > 0 && this.lstMaterialFull.length > 0) {
                const material = this.lstMaterialFull.find(function (v) {
                    return item.materialId == v.materialId;
                });
                if (material != undefined) {
                    const supplyId = ',' + material.supplyId + ',';
                    supplier = this.lstSupplier.filter(function (v) {
                        return supplyId.indexOf(',' + v.partnerId + ',') != -1;
                    });
                }
            }
            return supplier;
        },
        dateFormat(date) {
            return moment(String(date)).format('DD-MM-YYYY');
        },
        getHistory(importRequest) {
            axios.post(
                process.env.VUE_APP_API_URL + "/importRequest/searchHistory?importRequestId=" + importRequest.importRequestId).then(
                (data) => {
                    this.lstHistory = data;
                }
            );
        },
        checkMaterialTypePermission() {
            let materialType = this.$store.state.auth.user.materialType;
            console.log("materialType", materialType);
            //Neu khong phan quyen nhom vat tu thi la tat ca
            if(materialType == null || materialType == "null"){
              return
            }
            materialType = materialType.replace("[", ",");
            materialType = materialType.replace("]", ",");
            const lstMaterial_tmp = []
            const lstMaterial = this.lstMaterial;
            $.each(lstMaterial, function (k, v) {
                // console.log(v.typeId);
                if(materialType.indexOf(',' + v.typeId + ',') != -1){
                    lstMaterial_tmp.push(v);
                }
            });
            if (lstMaterial_tmp.length < lstMaterial.length) {
                this.isEdit = false;
            }
            this.lstMaterial = lstMaterial_tmp;
        },
    },

    destroyed() {},
};
</script>
